export const slugify = (str: string) => {
	// TODO: Fix this package using the wrong target lib
	// @ts-ignore // Property 'replaceAll' does not exist on type 'string'. Do you need to change your target library? Try changing the 'lib' compiler option to 'es2021' or later.
	return str.replaceAll(' ', '-').toLowerCase();
};
